import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import LoadingOverlay from "../../../shared/components/LoadingOverlay";
import testsActionCreators from "../../store/tests/action-creators";
import '../test-templates/TestTemplates.scss';
import './TestList.scss';
import {Alert} from "reactstrap";
import {withRouter} from "react-router-dom";
import classNames from 'classnames'

function mapStateToProps(state) {
  return {
    userContext: state.common.userContext,
    testsForGrade: state.tests.forGrade,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTestsForGrade() {
      return dispatch(testsActionCreators.fetchTestsForGrade());
    },
  };
}

class TestsForGrade extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isCreatingTestTemplate: false,
      isLoadingCreate: false,
      selectedOit: '',
      selectedTestTemplate: '',
      analyticsQuestions: [],
      analyticsTests: [],
      analyticsResultsMap: {},
      showTestsList: true,
    }
  }


  componentDidMount() {
    this.props.fetchTestsForGrade();
  }

  isCorrectAnswer(answersList, qeustionAnswers) {
    if (!answersList) {
      return false
    }

    if (!qeustionAnswers) {
      return answersList.correct
    }

    let correctAnswers = qeustionAnswers
      .filter(a => a.isCorrect)
      .map(a => a.id);

    let answers = answersList.answers || [];

    return correctAnswers.length === answers.length && correctAnswers.every(id => answers.includes(id));
  }

  generateTestsAnalytics() {
    const oitFilteredTests = this.props.tests.filter(tt => tt.test_template.id === this.state.selectedTestTemplate &&
      tt.status === 'completed');

    let analyticsQuestions = [];
    oitFilteredTests.reduce(function (acc, test) {
      test.questions.reduce(function (acc, question) {
        if (!analyticsQuestions.find(q => q.id === question.id)) {
          analyticsQuestions.push(question);
        }

        return acc;
      }, []);

      return acc;
    }, []);

    const that = this;
    let analyticsResultsMap = [];
    oitFilteredTests.reduce(function (acc, test) {
      test.questions.reduce(function (acc, question) {
        const currentQuestionAnswers = test.questions.find(q => q.id === question.id).answers;
        const currentQuestionAnsweredList = test.answers[question.id];

        analyticsResultsMap[test.id + '' + question.id] = that.isCorrectAnswer(currentQuestionAnsweredList, currentQuestionAnswers) + '';

        return acc;
      }, []);

      return acc;
    }, []);

    this.setState({
      analyticsQuestions,
      analyticsTests: oitFilteredTests,
      analyticsResultsMap,
      showTestsList: false,
    });
  }

  openTest(tt) {
    this.props.history.push(`/tests/${tt.id}`);
  }

  deleteTest(test) {
    this.props.deleteTest(test.id);
  }

  timeSpent(test) {
    if (test.finished_at) {
      const finishedAtMomentObj = moment(test.finished_at);
      const startedAtMomentObj = moment(test.started_at);

      const milisecondsDuration = moment.duration(finishedAtMomentObj.diff(startedAtMomentObj)).asMilliseconds();

      const secondsDuration = milisecondsDuration / 1000;
      const minutes = Math.floor(secondsDuration / 60);
      const seconds = Math.floor(secondsDuration % 60);

      const minutesParsed = minutes < 10 ? `0${minutes}` : minutes;
      const secondsParsed = seconds < 10 ? `0${seconds}` : seconds;

      return `${minutesParsed}:${secondsParsed}`;
    }

    return '';
  }

  testStatus(test) {
    if (test.status === 'completed') {
      return test.passed ? 'passed' : 'failed'
    }

    if (test.status === 'waiting') {
      return 'Needs grading';
    }

    return test.status;
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.state.isLoading}>
        <div className="app-content-header">
          <h4 className="title">Tests</h4>
        </div>

        <div className="test-templates app-content">
          <div className="test-templates-card">
            <div className="table-scrollable">
              {this.props.testsForGrade.length ? (
                <table className="table table-stripped layout-auto">
                  <thead>
                  <tr>
                    <th>
                      <div className="header">
                        <span>User</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Date</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Score </span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Time</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Passed</span>
                      </div>
                    </th>
                    <th>
                      <div className="header">
                        <span>Actions </span>
                      </div>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  {this.props.testsForGrade.map(tt => (
                    <tr key={tt.guid}>
                      <td>
                        {tt.user.firstName} {tt.user.lastName}
                      </td>
                      <td>
                        {tt.schedule &&
                        <span>{moment(tt.schedule).format('MM/DD/YYYY')}</span>
                        }
                      </td>
                      <td>{Math.round(tt.score)}</td>
                      <td>{this.timeSpent(tt)}</td>
                      <td className={classNames({
                        pending: this.testStatus(tt) === 'pending',
                        passed: this.testStatus(tt) === 'passed',
                        failed: this.testStatus(tt) === 'failed',
                        waiting: tt.status === 'waiting',
                      })}>
                        {this.testStatus(tt)}
                      </td>
                      <td>
                        {tt.status === 'pending' && this.props.userContext.hasScope('oit') &&
                        (
                          <button className="button small primary" onClick={() => this.openTest(tt)}>
                            <i className="fa fa-edit"/>
                            Take test
                          </button>
                        )}
                        {tt.status === 'completed' &&
                        (
                          (
                            <button className="button small primary" onClick={() => this.openTest(tt)}>
                              <i className="fa fa-file-archive-o"/>
                              View result
                            </button>
                          )
                        )}
                        {tt.status === 'pending' && this.props.userContext.hasScope(['fto', 'ftoc']) &&
                        (
                          <button className="button small danger" onClick={() => this.deleteTest(tt)}>
                            <i className="fa fa-trash"/>
                            Delete Test
                          </button>
                        )}
                        {tt.status === 'waiting' && this.props.userContext.hasScope(['fto', 'ftoc']) &&
                        (
                          <button className="button small secondary" onClick={() => this.openTest(tt)}>
                            <i className="fa fa-edit"/>
                            Grade Test
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              ) : <Alert color="primary">No tests</Alert>}
            </div>
          </div>
        </div>
      </LoadingOverlay>
    );
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(TestsForGrade));
